import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { selectedDayType } from "../../utils/types";

export const DaySelection = ({
  selectedDays,
  setSelectedDays,
  windowSize = 1000,
  preselectToday = false,
  preselectCurrentWeek = false,
}: {
  selectedDays;
  setSelectedDays;
  windowSize?: number;
  preselectToday?: boolean;
  preselectCurrentWeek?: boolean;
}) => {
  const [nextDays, setNextDays] = useState<selectedDayType[]>([]);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    day: selectedDayType
  ) => {
    if (event.target.checked) {
      setSelectedDays([...selectedDays, day]);
    } else {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    }
  };

  // set next days
  const getNextWorkdays = (currentDate: moment.Moment, windowSize) => {
    const nextWorkdays: {
      days: moment.Moment[];
      abbr: string;
    }[] = [];
    let daysToShow = 5;
    const weekday = currentDate.isoWeekday();
    if (weekday === 1) daysToShow = 7; // Mo -> So
    else if (weekday === 2) daysToShow = 6; // Di -> So
    else if (weekday === 3) daysToShow = 5; // Mi -> So
    else if (weekday === 4) daysToShow = 9; // Do -> nächster Fr
    else if (weekday === 5) daysToShow = 8; // Fr -> nächster Fr
    else if (weekday === 6) daysToShow = 7; // Sa -> nächster Fr
    else if (weekday === 7) daysToShow = 6; // So -> nächster Fr
    // const lastWeek = {
    //   abbr: "Letzte Woche",
    //   days: [],
    // };
    // for (let i = 7; i > 0; i--) {
    //   lastWeek.days.push(currentDate.clone().subtract(i, "days"));
    // }
    // nextWorkdays.push(lastWeek);
    if (currentDate.isoWeekday() <= 50) {
      //vorher 5 (Werktage)
      nextWorkdays.push({
        abbr: "Heute",
        days: [currentDate.clone()],
      });
    }
    while (nextWorkdays.length < daysToShow) {
      currentDate = currentDate.add(1, "day");
      if (currentDate.isoWeekday() <= 50) {
        //vorher 5 (Werktage)
        let newAbbr = currentDate
          .format("dd")
          .replace("Tu", "Di")
          .replace("We", "Mi")
          .replace("Th", "Do")
          .replace("Su", "So");
        if (windowSize >= 700) newAbbr += " " + currentDate.format("DD.MM.");
        nextWorkdays.push({
          abbr: newAbbr,
          days: [currentDate.clone()],
        });
      }
    }
    // const nextWeek = {
    //   abbr: "Nächste Woche",
    //   days: [],
    // };
    // for (let i = 1; i <= 7; i++) {
    //   nextWeek.days.push(currentDate.clone().add(i, "days"));
    // }
    // nextWorkdays.push(nextWeek);
    setNextDays(nextWorkdays);
  };

  useEffect(() => {
    const currentDate = moment().startOf("day");
    getNextWorkdays(currentDate, windowSize);
  }, []);

  useEffect(() => {
    if (preselectToday && nextDays?.filter((day) => day.abbr === "Heute")[0])
      setSelectedDays([
        ...selectedDays,
        nextDays?.filter((day) => day.abbr === "Heute")[0],
      ]);
    if (
      preselectCurrentWeek &&
      nextDays?.filter(
        (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche"
      )
    )
      setSelectedDays([
        ...selectedDays,
        ...nextDays?.filter(
          (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche"
        ),
      ]);
  }, [nextDays]);

  if (windowSize < 700) {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FormGroup aria-label="position" row>
            {nextDays &&
              nextDays
                .filter(
                  (day) =>
                    day.abbr !== "Nächste Woche" && day.abbr !== "Letzte Woche"
                )
                .map((day, index) => (
                  <FormControlLabel
                    key={day.days[0].format("DD.MM.YYYY")}
                    value="top"
                    control={
                      <Checkbox
                        checked={selectedDays.includes(day)}
                        onChange={(event) => {
                          if (event.target.checked) {
                            setSelectedDays([day]);
                          } else {
                            setSelectedDays([]);
                          }
                        }}
                      />
                    }
                    label={day.abbr}
                    labelPlacement="top"
                    style={{ margin: 8 }}
                  />
                ))}
          </FormGroup>{" "}
        </div>
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <FormGroup aria-label="position" row>
            {nextDays &&
              nextDays
                .filter(
                  (day) =>
                    day.abbr === "Nächste Woche" || day.abbr === "Letzte Woche"
                )
                .map((day, index) => (
                  <FormControlLabel
                    key={day.days[0].format("DD.MM.YYYY")}
                    value="top"
                    control={
                      <Checkbox
                        onChange={(event) => handleCheckboxChange(event, day)}
                        defaultChecked={
                          (day.abbr === "Heute" && preselectToday) ||
                          (day.abbr !== "Nächste Woche" &&
                            day.abbr !== "Letzte Woche" &&
                            preselectCurrentWeek)
                        }
                      />
                    }
                    label={day.abbr}
                    labelPlacement="top"
                    style={{ margin: 8 }}
                  />
                ))}
          </FormGroup>
        </div> */}
      </>
    );
  }
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <FormGroup aria-label="position" row>
        {nextDays &&
          nextDays.map((day, index) => (
            <FormControlLabel
              key={day.days[0].format("DD.MM.YYYY")}
              value="top"
              control={
                <Checkbox
                  checked={selectedDays.includes(day)}
                  onChange={(event) => {
                    if (event.target.checked) {
                      setSelectedDays([day]);
                    } else {
                      setSelectedDays([]);
                    }
                  }}
                />
              }
              label={day.abbr}
              labelPlacement="top"
              style={{ margin: 8 }}
            />
          ))}
      </FormGroup>{" "}
    </div>
  );
};
